var render = function render(_c,_vm){return _c('h2',{staticClass:"grid-title"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }